import { css } from '@emotion/react'
import { mTheme } from '../../style/themes'

let { breakpoint, size } = mTheme

export const belowHeader = css({
  display: 'grid',
  paddingTop: size.S,
  [breakpoint.medium]: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: size.L,
    justifyContent: 'center',
  },
})

export const container = css({
  display: 'grid',
})

export const mobileFooter = css({
  margin: `${size.S} auto`,
  paddingLeft: size.XS,
  ul: {
    flexDirection: 'column',
  },
  [breakpoint.medium]: {
    display: 'none',
  },
})

export const errorContainer = css({
  padding: size.S,
})

export const errorStackTrace = css({
  padding: '2rem',
  background: 'hsla(10, 50%, 50%, 0.1)',
  color: 'red',
  overflow: 'auto',
  width: '100%',
})
